import notificationsModule from '@notifications/module/store/type';

const getters = {
    userProfile: state => {
        return state.profile
    },
    availableEmojies: state => {
      return state.availableEmojies;  
    },
    spotTags: state => {
        return state.spot_tags;
    },
    emojiCode: (state,getters) => id => {
        return getters.availableEmojies.find(emoji => {
            return emoji.id === id
        }).emoji_code
    },
    favorites:(state) => {
        return state.favourites;
    },
    getFavoritesPage: (state) => {
        return state.favoritesPage;
    },
    publicPhotos: state => {
        return state.profilePhotos.filter(p => p.visible_to === 'public' && p.is_default === 'no');
    },
    privatePhotos: state => {
        return state.profilePhotos.filter(p => p.visible_to === 'private');
    },
    photos: (state) => {
      return state.profilePhotos;
    },
    publicVideos: state => {
        return state.profileVideos.filter(p => p.visible_to === 'public');
    },
    privateVideos: state => {
        return state.profileVideos.filter(p => p.visible_to === 'private' || !p.id);
    },
    publicPhotosCount: (state, getters) => {
        return getters.publicPhotos.length;
    },
    publicVideosCount: (state, getters) => {
        return getters.publicVideos.length;
    },
    defaultPhoto: (state, getters) => {
        return getters.publicPhotos.find(v => v.is_default == 'yes');
    },
    unitSystem: state => {
        return state.profile.unit_system;
    },
    profileOptions: state => {
        return state.profileOptions;
    },
    sortedProfilePhotos: state => {
        let arr = state.profilePhotos.slice();
        console.log('[Getter] sortedProfilePhotos', { arr })
        return arr.sort((a, b) => {
            if (a.is_default == 'yes') {
                return -1;
            }
            if (b.is_default == 'yes') {
                return 1;
            }
            return b.id - a.id;
        });
    },
    sortedProfileVideos: state => {
        let arr = state.profileVideos.slice();
        console.log('[Getter] sortedProfileVideos', { arr })
        return arr.sort((a, b) => {
            return b.id - a.id;
        });
    },
    discreetModeEnabled(state) {
        return state.discreetMode
    },
    meetNowStatus(state){
        return state.profile.meet_now;
    },
    meetNowAvailable(state){
        return state.profile.meet_now_available;
    },
    meetNowUsers(state){
        return state.meetNowUsers;
    },
    timezones(state){
        return state.timezones;
    },
    getUser: state => userId => {
        const userById = state.usersInfo[userId]
        if (userById) {
            return userById
        }

        for (let key in state.usersInfo) {
            if (
                key !== 'undefined'
                &&
                state.usersInfo.hasOwnProperty(key)
                &&
                state.usersInfo[key].link === userId
            ) {
                return state.usersInfo[key]
            }
        }

        return null
    },
    getEvent: state => eventId => {
        return state.eventsInfo[eventId] || null
    },
    getSpot: state => spotId => {
        return state.spotsInfo[spotId] || null
    },
    getMyEvent: state => eventId => {
        return state.myEvents.find(e => e.id === eventId);
    },
    getMyClub: state => clubId => {
        return state.myClubs.find(c => c.id === clubId);
    },
    getClub: state => clubId => {
        return state.clubsInfo[clubId] || null
    },
    getInvitationsToBang: state => {
        return state.invitationsToBang || null
    },
    getInvitationsToClub: state => {
        return state.invitationsToClub || null
    },
    userHasNewMessages: state => {
        return state.profile.has_new_messages
    },
    userHasNotifications: (state) => {
        return state.profile.has_notifications
    },
    userHasEventNotifications: (state) => {
        return state.profile.has_event_notifications
    },
    userHasClubNotifications: (state) => {
        return state.profile.has_club_notifications
    },
    userHasNewVisitors: state => {
        return state.profile.has_new_visitors
    },
    userHasNewNotifications: state => {
        return state.profile.has_new_notifications
    },
    profileEditOpened: state => {
        return state.profileEditOpened
    },
    profileLocationOpened: state => {
        return state.profileLocationOpened
    },
    profilePhotosOpened: state => {
        return state.profilePhotosOpened
    },
    profileVideosOpened: state => {
        return state.profileVideosOpened
    },
    profileSettingsOpened: state => {
        return state.profileSettingsOpened
    },
    profileShareOpened: state => {
        return state.profileShareOpened
    },
    profileModerationOpened: state => {
        return state.profileModerationOpened
    },
    profileDeactivationOpened: state => {
        return state.profileDeactivationOpened
    },
    customizeSharingLinksOpened: state => {
        return state.customizeSharingLinksOpened
    },
    deleteAllSharingLinksOpened: state => {
        return state.deleteAllSharingLinksOpened
    },
    profileHelpOpened: state => {
        return state.profileHelpOpened
    },
    sharingUrl: state => {
        return state.sharingUrl
    },
    getSocketStatus: state => {
        return state.socketConnected
    }
}

export default getters
